import { svgIconClassName } from '@fluentui/react-icons-northstar';
export var attachmentIconStyles = {
  root: function root(_ref) {
    var _ref2;

    var v = _ref.variables;
    return _ref2 = {
      height: v.iconSize,
      width: v.iconSize,
      marginRight: v.iconSpace
    }, _ref2["& ." + svgIconClassName] = {
      height: '100%',
      width: '100%',
      '& svg': {
        height: '100%',
        width: '100%'
      }
    }, _ref2;
  }
};
//# sourceMappingURL=attachmentIconStyles.js.map
